function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    disabled
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => _extends({
    color: theme.palette.neutral.default,
    padding: theme.layout.size1
  }, disabled && {
    color: theme.palette.foreground.disabled
  }, {
    '&:hover': {
      background: theme.palette.neutral.backgroundLight,
      color: theme.palette.neutral.hover
    },
    '&:active': {
      background: theme.palette.neutral.background,
      color: theme.palette.neutral.active
    }
  }), [disabled, theme]);
};
export default useStyles;